var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{class:_vm.collapseCls,on:{"click":_vm.onChange}},[_vm._v(_vm._s(_vm.collapsed ? "收起" : "展开")),_c('i',{staticClass:"el-icon-arrow-down el-icon--right"})])}
var staticRenderFns = []

export { render, staticRenderFns }